import { motion } from "framer-motion";
import Seo from "@/components/Seo";
import PageHeader from "@/components/PageHeader";
import CtaBand from "@/components/CtaBand";
import ServiceCard from "@/components/ServiceCard";
import { SERVICES, CCTV_SERVICE } from "@/data/services";

export default function Services() {
  return (
    <>
      <Seo
        title="Electrical Services"
        description="Residential, commercial, and industrial electrical services from Kensmarc Electric: panel upgrades, EV chargers, generators, lighting, new construction, troubleshooting, and more."
        path="/services"
      />
      <PageHeader
        eyebrow="Our Services"
        title="Electrical services for every project"
        subtitle="Kensmarc Electric handles residential, commercial, and industrial electrical work across Los Angeles County. Every service leads to a straightforward quote request — no fixed pricing games."
      />

      <section className="section-pad">
        <div className="container-kx grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
          {SERVICES.map((s, i) => (
            <motion.div
              key={s.slug}
              initial={{ opacity: 0, y: 18 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ delay: (i % 3) * 0.05 }}
            >
              <ServiceCard
                to={`/services/${s.slug}`}
                testId={`service-card-${s.slug}`}
                Icon={s.Icon}
                name={s.name}
                category={s.category}
                short={s.short}
                workTypes={s.workTypes}
                index={i}
              />
            </motion.div>
          ))}

          <motion.div
            initial={{ opacity: 0, y: 18 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: (SERVICES.length % 3) * 0.05 }}
          >
            <ServiceCard
              to="/cctv-security"
              testId="service-card-cctv"
              Icon={CCTV_SERVICE.Icon}
              name={CCTV_SERVICE.name}
              category={CCTV_SERVICE.category}
              short={CCTV_SERVICE.short}
              workTypes={CCTV_SERVICE.workTypes}
              index={SERVICES.length}
            />
          </motion.div>
        </div>
      </section>

      <CtaBand />
    </>
  );
}
